import Images from './Images';

const types = {
    s: 'grayscale',
    m: 'color',
    l: 'animation'
};

const sizes = {
    s: '16px',
    m: '24px',
    l: '32px'
};

export const isRetina = function() {
    let mediaQuery = `(-webkit-min-device-pixel-ratio: 1.5),
            (min--moz-device-pixel-ratio: 1.5),
            (-o-min-device-pixel-ratio: 3/2),
            (min-resolution: 1.5dppx)`;
    if (typeof window !== 'undefined') {
        return !!(window.devicePixelRatio > 1 || ((window.matchMedia && window.matchMedia(mediaQuery).matches)));
    }
    return false;
};

export const getIconProps = (iconType, iconSize, color) => {
    let iconProps = {
        style: {
            width: sizes[iconSize],
            height: sizes[iconSize]
        },
        src: Images[`${iconType}_${types[iconSize].toUpperCase()}`]
    };
    if (iconSize === 's' && color) {
        iconProps.src = Images[`${iconType}_${'color_small'.toUpperCase()}`];
    }
    if (iconSize === 'l' && isRetina()) {
        iconProps.src = Images[`${iconType}_${types[iconSize].toUpperCase()}_DOUBLE`];
    }
    return iconProps;
};
